// function getHostName() {
//     if (typeof window !== "undefined") {
//         console.log("window:", window);
//         console.log("window.location.hostname:", window.location.hostname);
//         return window.location.hostname;
//     }
// }

// console.log("getHostName:", getHostName());
export const REQUEST_URL = "/new-graphql";
// export const REQUEST_URL = "https://localhost:4224/new-graphql";
